// AwaitableEvent.ts — ES5-friendly
export class AwaitableEvent<TResponse> {
  readonly promise: Promise<TResponse>;

  private _resolve!: (v: TResponse) => void;
  private _reject!: (e?: unknown) => void;
  private _settled = false;
  private _timer?: ReturnType<typeof setTimeout>;

  constructor(opts?: { timeoutMs?: number }) {
    const timeoutMs = opts?.timeoutMs ?? 10_000;

    this.promise = new Promise<TResponse>((res, rej) => {
      this._resolve = res;
      this._reject = rej;
    });

    if (timeoutMs > 0) {
      this._timer = setTimeout(() => this._fail(new Error(`AwaitableEvent timed out after ${timeoutMs}ms`)), timeoutMs);
    }
  }

  reply(value: TResponse) {
    if (this._settled) return;
    this._settled = true;
    if (this._timer) clearTimeout(this._timer);
    this._resolve(value);
  }

  fail(err?: unknown) {
    this._fail(err);
  }

  get settled() {
    return this._settled;
  }

  private _fail(err?: unknown) {
    if (this._settled) return;
    this._settled = true;
    if (this._timer) clearTimeout(this._timer);
    this._reject(err instanceof Error ? err : new Error(String(err ?? "Unknown error")));
  }
}
